import { Action, createReducer, on } from '@ngrx/store';
import { expiringCredentialCountActions } from '../actions';
import { Store_ExpiringCredentialCount } from '../actions/expiring-credential-count.model';

const initialState: Store_ExpiringCredentialCount = {
  userCount: 0,
  totalCount: 0
} as const;

const _expiringCredentialCountReducer = createReducer(
  initialState,
  on(expiringCredentialCountActions.updateExpiringCredentialsCount, (state, { userCount, totalCount }) => {
    return { ...state, userCount, totalCount };
  })
);

export function expiringCredentialCountReducer(
  state: Store_ExpiringCredentialCount | undefined,
  action: Action
): Store_ExpiringCredentialCount {
  return _expiringCredentialCountReducer(state, action);
}
